import React, { memo, FC } from 'react';
import { IM07VideoBlock, IM07YoutubeVideoBlock, IVideo } from '@montana/models/generated/cms.interface';
import { Media } from '@montana/shared/media';
import { epiMediaRatioToEnum } from '@montana/helpers/epi-mapping.helper';

export const M07VideoBlock: FC<IM07VideoBlock> = memo((props: IM07VideoBlock): JSX.Element => {
    const {
        video,
        autoPlay,
        muteSound,
        alignment,
    } = props;

    return (
        <section className={`video-block video-block--${alignment}`}>
            {video?.url && <Media video={video} videoAutoplay={autoPlay} videoMuted={muteSound} mediaRatio={epiMediaRatioToEnum('video')} placeholder />}
        </section>
    )
});

export const M07YoutubeVideoBlock: FC<IM07YoutubeVideoBlock> = memo((props: IM07YoutubeVideoBlock): JSX.Element => {
    const {
        youtubeVideoUrl,
        autoPlay,
        muteSound,
        coverImage,
        alignment,
    } = props;

    const video: IVideo = {
        url: youtubeVideoUrl,
        coverImage,
    }

    return (
        <section className={`video-block video-block--${alignment}`}>
            {youtubeVideoUrl && <Media video={video} videoAutoplay={autoPlay} videoMuted={muteSound} placeholder />}
        </section>
    )
});
